<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">{{!selectDocumento ? 'Agregar' : 'Editar'}} Documento</label>
      </header>
      <form [formGroup]="formDocumento" (ngSubmit)="onOperarDocumento()">
        <div class="form-group">
          <label class="small text-secondary" for="tipo_dato_id">Tipo de dato</label>
          <select class="form-control form-control-sm"
          id="tipo_dato_id"
          (change)="tipoDatoSelected($event)"
          formControlName="tipo_dato_id">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" *ngFor="let option of listTipoDato; let i = index" value="{{option?.tipo_dato_id}}"
              [selected]="false">
              {{option?.descripcion}}
            </option>
          </select>
          <!-- Tipo Dato: MULTIPLE -->
          <div id="containerPreguntasMultiples" class="d-none mt-2">
            <ul class="list-group" id="listaRespuesta">
              <li class="list-group-item" id="respuesta_{{item.index}}" *ngFor="let item of listadoRespuesta">
                <div class="row">
                  <div class="col-md-3">
                    Rpta. {{ item.index }}
                  </div>
                  <div class="col-md-7">
                    <input type="text" class="form-control" name="inputRespuestas[]" [value]="item.respuesta">
                  </div>
                  <div class="col-md-2">
                    <img src="../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25"
                      (click)="eliminarRespuesta(item.index)">
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <button type="button" class="btn btn-secondary btn-sm" (click)="agregarRespuesta()">
                      Agregar respuesta
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- Tipo Dato: VARIOS REGISTROS -->
          <div id="containerCampoRegistros" class="d-none mt-2">
            <label class="small text-secondary" for="Nombre_varios_registros">Campo de registro</label>
            <input type="text" id="Nombre_varios_registros" formControlName="Nombre_varios_registros" class="form-control form-control-sm">



            <div class="invalid-feedback"
            *ngIf="formDocumento.get('Nombre_varios_registros').invalid &&
            (formDocumento.get('Nombre_varios_registros').dirty ||
            formDocumento.get('Nombre_varios_registros.touched'))">
              <div *ngIf="formDocumento.Nombre_varios_registros.errors?.pattern">
              Please enter username
            </div>


            <div class="invalid-feedback"
              *ngIf="this.formDocumento.controls.Nombre_varios_registros.errors.pattern">
              okokokoko
            </div>
          </div>




          </div>
          <!-- Tipo Dato: MULTIPLE CARACTERISTICA -->
          <div id="containerMultipleCaracteristica" class="d-none mt-2">
            <ul class="list-group" id="listaRespuesta">
              <li *ngFor="let item of listadoMultipleCarac; let i = index;"
              class="list-group-item mb-2" style="background-color: #EBEBEB;">
                <div class="row">
                  <div class="col-md-10">
                    <label for="titulo_mult_carac" class="small">Titulo del campo</label>
                  </div>
                  <div class="col-md-2 text-right">
                    <a href="javascript:void(0)" (click)="eliminarMultipleCaracteristica(i)">
                      <mat-icon class="multiple-delete-icon text-dark">delete</mat-icon>
                    </a>
                  </div>
                </div>
                <input type="text" id="titulo_mult_carac_{{i}}" name="titulo_mult_carac[]"
                class="form-control form-control-sm" [value]="item.descripcion">

                <label for="titulo_mult_carac" class="small">Caracteristica del campo</label>
                <select name="caracteristica_mult_carac[]" id="caracteristica_mult_carac_{{i}}"
                class="form-control form-control-sm" value>
                  <option value="" selected>Seleccione</option>

                  <option *ngFor="let feature of multipleFeatureData; let j = index"
                  value="{{feature.caracteristicas_opciones_id}}" [selected]="item.caracteristicas_opciones_id == feature.caracteristicas_opciones_id ? true : false">
                    {{feature.descripcion}}
                  </option>
                </select>
              </li>
            </ul>

            <div id="ContainerAlertFormMC" class="d-none fs-6 text" style="color: red;">
              Por favor, verificar la informacion ingresada, hay campos vacios.
            </div>

            <div class="text-center w-100">
              <button type="button" (click)="crearNuevoCampo()" class="btn btn-secondary mt-3">Crear nuevo campo</button>
            </div>
          </div>

        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Requiere Número de certificado</label>
          <select class="form-control form-control-sm" id="requiere_numero_certificado"
            formControlName="requiere_numero_certificado">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Sí
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              No
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Descripción</label>
          <textarea id="descripcion" formControlName="descripcion" class="w-100 form-control mb-2"></textarea>
        </div>

        <label class="small text-secondary">Tipo de prestador</label><br>
        <mat-checkbox color="primary"
        (change)="commercialResult( $event.checked, 'aplica_comerciante' )"
        formControlName="aplica_comerciante">
          <label class="small text-secondary category-check" for="nit">Se muestra para Comerciante</label>
        </mat-checkbox>
        <mat-checkbox color="primary"
        (change)="commercialResult( $event.checked, 'aplica_no_comerciante' )"
        formControlName="aplica_no_comerciante">
          <label class="small text-secondary category-check" for="nit">Se muestra para No comerciante</label>
        </mat-checkbox>

        <div class="form-group">
          <label class="small text-secondary" for="nit">Estado</label>
          <select class="form-control form-control-sm" id="activo" formControlName="activo"
            [attr.disabled]="!selectDocumento ? '' : null">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Activo
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              Inactivo
            </option>
          </select>
        </div>
        <div class="form-row mt-5">
          <button type="button" class="btn btn-outline-primary border-0 m-auto"
            (click)="limpiarDocumento()">Limpiar</button>
          <button class="btn btn-primary m-auto " [disabled]="!formDocumento.valid" type="submit">{{!selectDocumento
            ? 'Agregar' : 'Editar'}}</button>
        </div>
      </form>
    </section>
    <section class="col-9 p-4 mt-5 mb-5">
      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Listado de Documentos</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>

      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Número de documento</label>
                  <select class="form-control form-control-sm" id="requiere_numero_certificado"
                    formControlName="requiere_numero_certificado">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Descripción</label>
                  <input id="descripcion" formControlName="descripcion" type="text"
                    class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Estado</label>
                  <select class="form-control form-control-sm" id="activo" formControlName="activo">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Activo
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Inactivo
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto"
                    (click)="limpiar()">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>


      <div class="table-responsive">
        <app-tablas [page] = "paginaActual" [headers]="headerDocumento" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)"
          class="table-responsive">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.descripcion}}</td>
            <td>{{item.descripcion_tipo_dato}}</td>
            <td>{{item.requiere_numero_certificado ? 'Sí' : 'No'}}</td>
            <td>{{item.aplica_comerciante ? 'Sí' : 'No'}}</td>
            <td>{{item.aplica_no_comerciante ? 'Sí' : 'No'}}</td>
            <td>{{item.activo ? 'Activo' : 'Inactivo'}}</td>
            <td class="d-flex flex-row">
              <img *ngIf="item.descripcion_tipo_dato === 'MULTIPLE'" src="../../../../../../../assets/icons/associate.png" class="pointer" alt="" height="25"
                (click)="openAssociateQuestions(item)">
              <img src="../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25"
                (click)="onCargarDocumento(item)">
              <img src="../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25"
                (click)="onEliminarDocumento(item)">
            </td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>
